import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { Arrow } from 'components/CommonIcons';

import getArrowProps from './utils/getArrowProps';
import * as styles from './SortingArrows.scss';

/**
 * Reusable SortingArrows Component
 * @function SortingArrows
 * @param {Object}
 * @return {ReactElement}
 */
const SortingArrows = ({ arrowClassName, className, currentField, sortBy, sortDirection, style }) => {
  return (
    <div className={classNames(styles.sortingArrows, className)} style={style}>
      <Arrow {...getArrowProps({ arrowClassName, arrowDirection: 'ASC', currentField, sortBy, sortDirection })} />
      <Arrow {...getArrowProps({ arrowClassName, arrowDirection: 'DESC', currentField, sortBy, sortDirection })} />
    </div>
  );
};

SortingArrows.propTypes = {
  currentField: PropTypes.string.isRequired,
  sortBy: PropTypes.string.isRequired,
  sortDirection: PropTypes.string.isRequired,
  arrowClassName: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]),
  ),
};

export default SortingArrows;
